/* istanbul ignore file */
export { default } from './NumberPortIn';
